export default [
  {
    path: '/career',
    name: 'career',
    component: () => import('@/views/page/career/career.vue'),
    meta: {
      layout: 'job'
    }
  },
  {
    path: '/job-post/:jobPostSlug/details',
    name: 'job-post-details',
    component: () => import('@/views/page/career/JobPostDetails.vue'),
    meta: {
      layout: 'job'
    }
  },
  {
    path: '/job-applicant/my-profile',
    name: 'job-applicant-profile',
    component: () => import('@/views/page/career/ContactMyProfile.vue'),
    meta: {
      requiresAuth: true,
      layout: 'job'
    }
  },
  {
    path: '/job-application-list',
    name: 'job-application-list',
    component: () => import('@/views/page/career/JobApplicationList.vue'),
    meta: {
      requiresAuth: true,
      layout: 'job'
    }
  },
]